angular.module('TurneroApp').component('coTramitesAlta', {
    bindings: {
        ctrlPadre: '='
    },
    controller: [
        'tramitesService',
        '$location',
        '$anchorScroll',
        'utilsService',
        'TurneroAppConstant',
        function (tramitesService, $location, $anchorScroll, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.tramiteAlta = {};

            ctrl.errores = {
                nombre: false,
                id: false
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.tramiteAlta = {};

                    ctrl.errores = {
                        nombre: false,
                        id: false
                    };

                    tramitesService.getData({ 'IdTramite': '' }).$promise.then(function (data) {
                        ctrl.tramiteAlta = data;
                    }).catch(function (error) {
                        utilsService.errores(error)
                    });
                }
            }


            ctrl.guardarTramiteNuevo = function () {
                ctrl.errores.nombre = !ctrl.tramiteAlta.NTramite;
                ctrl.errores.id = !ctrl.tramiteAlta.IdTramite;

                if (ctrl.errores.nombre) {
                    $anchorScroll();
                    return;
                }

                tramitesService.save(ctrl.tramiteAlta).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Alta Trámite", "El trámite se registró correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });

            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./tramitesAlta.html')
});


// WEBPACK FOOTER //
// ./app/components/tramites/tramitesAltaComponent.js